// extracted by mini-css-extract-plugin
module.exports = {"base":"ServiceLogo_base__sECJ0","on3":"ServiceLogo_on3__rlm6R"};